import React from 'react';
import Map from '../../components/MapComponents/Map';
import WithMapConfig from '../../hocs/WithMapConfig';

const CustomMap = (props) => {
	return <Map {...props} />;
};

export default WithMapConfig(CustomMap);
